<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page"><i class="fas fa-life-ring"></i> Help - Product Contract Statuses</li>
            </ol>
        </nav>

        <h4 class="page-header">
            <i class="fas fa-life-ring"></i> Help - Product Contract Statuses
        </h4>

        <div class="card">
            <div class="card-body">
                <v-client-table ref="prodContractStatusTable" :columns="contractStatusColumns" :options="contractStatusOptions" :data="statuses">

                    <template slot="contract_status_desc" slot-scope="props">
                        <div v-html="$sanitize(props.row.contract_status_desc)" />
                    </template>

                    <template slot="contract_status_color" slot-scope="props">
                        <span :class="'badge badge-'+props.row.contract_status_color">Color</span>
                    </template>

                    <template slot="include_on_downline" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.include_on_downline == 1">Include on Downline</label>
                        <label class="badge badge-warning" v-else-if="props.row.include_on_downline == 0">Exclude on Downline</label>
                    </template>

                    <template slot="display_as_inactive" slot-scope="props">
                        <label class="badge badge-secondary" v-if="props.row.display_as_inactive == 1">Display as Inactive</label>
                        <label class="badge badge-success" v-else-if="props.row.display_as_inactive == 0">Display as Active</label>
                    </template>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                saving: false,
                user: this.$store.state.user,
                errors: {},
                searchTerm: this.$route.query.q,

                //Search Entities
                agents: [],
                agencies: [],
                contracts: [],
                clients: [],
                policies: [],

                statuses: [],
                contractStatusColumns: [
                    'contract_status_name',
                    'contract_status_type',
                    'contract_status_color',
                    'contract_status_desc',
                    'include_on_downline',
                    'display_as_inactive',
                ],
                contractStatusOptions: {
                    skin: "table table-bordered table-sm table-hover",
                    headings: {
                        contract_status_name: 'Status Name',
                        contract_status_type: 'Status Type',
                        contract_status_color: 'Status Color',
                        contract_status_desc: 'Description',
                        include_on_downline: 'Include on Downline',
                        display_as_inactive: 'Display on Profile',
                    },
                    texts:{
                        filterPlaceholder:"Search Contract Statuses",
                    },
                    orderBy: {
                        ascending: true,
                        column: 'contract_status_name',
                    },
                    uniqueKey: 'id',
                    rowClassCallback: row => {
                        return "alert-"+row.contract_status_color;
                    }
                },
            }
        },

        computed: {

        },

        methods: {

            getSearchResults(){
                //Helpers
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http
                .get('/help/contract-statuses', this.$route.query)
                .then(response => {
                    //Set All
                    this.statuses = response.data.statuses;

                    //Return to main list?
                    //this.$router.push('/');
                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data.errors;
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.e(error.response.data, 'Failed to load Help Page');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }

        },

        mounted() {
            //Get it
            this.getSearchResults();
        }
    }
</script>
